import { render, staticRenderFns } from "./ZDialog.vue?vue&type=template&id=2d3e5046&scoped=true&"
import script from "./ZDialog.vue?vue&type=script&lang=js&"
export * from "./ZDialog.vue?vue&type=script&lang=js&"
import style0 from "./ZDialog.vue?vue&type=style&index=0&id=2d3e5046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e5046",
  null
  
)

export default component.exports